"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/NCFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_167)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_167`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.4397 16.48H34.5575V24H-1.4397V16.48Z",
					fill: "#009543"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.4397 7.42432H34.5575V16.4967H-1.4397V7.42432Z",
					fill: "#ED4135"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.4397 0H34.5575V7.49754H-1.4397V0Z",
					fill: "#0035AD"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0592 20.8445C16.9455 20.8445 20.9067 16.8834 20.9067 11.9971C20.9067 7.11079 16.9455 3.14966 12.0592 3.14966C7.17292 3.14966 3.21179 7.11079 3.21179 11.9971C3.21179 16.8834 7.17292 20.8445 12.0592 20.8445Z",
					fill: "#FAE600",
					stroke: "black",
					strokeWidth: .298102
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.8783 19.939L14.0897 20.6139L12.0592 20.8502L9.93316 20.7152L7.91394 19.8434C7.91394 19.8434 9.52256 18.1954 10.2031 17.9591C10.6868 17.7904 11.463 17.751 11.463 17.751V6.86187L11.4462 3.14966H12.3967L12.3686 6.94624V17.7285C12.3686 17.7285 13.2292 17.796 13.6116 17.9591C14.2472 18.2347 15.8783 19.939 15.8783 19.939Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.5253 5.75814L12.9413 4.55347L13.255 5.18269L10.839 6.3873L10.5253 5.75814Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9355 17.2674C12.4574 17.2674 12.8805 16.6001 12.8805 15.7769C12.8805 14.9537 12.4574 14.2864 11.9355 14.2864C11.4137 14.2864 10.9906 14.9537 10.9906 15.7769C10.9906 16.6001 11.4137 17.2674 11.9355 17.2674Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.913 9.2412C12.5622 9.2412 13.0885 8.7149 13.0885 8.06567C13.0885 7.41644 12.5622 6.89014 11.913 6.89014C11.2637 6.89014 10.7374 7.41644 10.7374 8.06567C10.7374 8.7149 11.2637 9.2412 11.913 9.2412Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9693 12.554C12.5874 12.554 13.0886 12.2493 13.0886 11.8734C13.0886 11.4976 12.5874 11.1929 11.9693 11.1929C11.3511 11.1929 10.85 11.4976 10.85 11.8734C10.85 12.2493 11.3511 12.554 11.9693 12.554Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.5856 9.95557H13.2291V10.518H10.5856V9.95557ZM10.5856 13.1616H13.2291V13.724H10.5856V13.1616Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_167`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as NCFlag };
